import React, { useState, useEffect } from 'react';
import Select from './Select';

// Native <input type="time"> renders 24h vs 12h based on the browser/OS
// locale (e.g. Safari on a 24h-locale Mac shows no AM/PM at all), so we
// can't rely on it to always show an AM/PM picker. This renders hour /
// minute / AM-PM as three explicit dropdowns instead, storing the same
// "HH:MM" 24-hour string the rest of the app already works with.
const HOUR_OPTIONS   = Array.from({ length: 12 }, (_, i) => ({ value: i + 1, label: String(i + 1) }));
const MINUTE_OPTIONS = Array.from({ length: 60 }, (_, i) => ({ value: i, label: String(i).padStart(2, '0') }));
const PERIOD_OPTIONS = [{ value: 'AM', label: 'AM' }, { value: 'PM', label: 'PM' }];

const parse24 = (value) => {
  if (!value) return { hour: '', minute: '', period: '' };
  const [h, m] = value.split(':').map(Number);
  return { hour: h % 12 || 12, minute: m, period: h >= 12 ? 'PM' : 'AM' };
};

const to24 = (hour, minute, period) => {
  let h = hour % 12;
  if (period === 'PM') h += 12;
  return `${String(h).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
};

const TimeInput = ({ value, onChange, style }) => {
  const [parts, setParts] = useState(() => parse24(value));

  useEffect(() => { setParts(parse24(value)); }, [value]);

  const update = (patch) => {
    const next = { ...parts, ...patch };
    setParts(next);
    if (next.hour !== '' && next.minute !== '' && next.period !== '') {
      onChange(to24(Number(next.hour), Number(next.minute), next.period));
    }
  };

  const buttonStyle = { padding: '6px 8px', fontSize: '14px' };

  return (
    <div style={{ display: 'flex', gap: '6px', ...style }}>
      <Select value={parts.hour}   onChange={v => update({ hour: v })}   options={HOUR_OPTIONS}   style={{ width: '58px' }} buttonStyle={buttonStyle} />
      <Select value={parts.minute} onChange={v => update({ minute: v })} options={MINUTE_OPTIONS} style={{ width: '64px' }} buttonStyle={buttonStyle} />
      <Select value={parts.period} onChange={v => update({ period: v })} options={PERIOD_OPTIONS} style={{ width: '68px' }} buttonStyle={buttonStyle} />
    </div>
  );
};

export default TimeInput;
